<template>
  <div class="wrap">
    <header>
      <h2>{{lang.myTeam}}</h2>
      <!-- <span @click="showRule=!showRule"><i class="iconfont icon-kongxinwenhao"></i></span> -->
    </header>
    <div class="main">
      <div class="totalTj">
        <p @click="lookDetail('showTeams',lang.teams,0)">
          <span>{{lang.teams}}</span>
          <span>{{teams}}</span>
        </p>
        <p @click="lookDetail('showTeams',lang.client,1)">
          <span>{{lang.client}}</span>
          <span>{{tmToday}}</span>
        </p>
        <p @click="lookDetail('showTmCk',lang.tmDeposit,0)">
          <span>{{lang.tmDeposit}}</span>
          <span>{{currSymbol}}{{teamDeposit}}</span>
        </p>
<!--        <p @click="lookDetail('showTmValid',lang.valid_teams,0)">-->
<!--          <span>{{lang.valid_teams}}</span>-->
<!--          <span>{{teamsValid}}</span>-->
<!--        </p>-->
<!--        <p @click="lookDetail('showTmValid',lang.clientValid,1)">-->
<!--          <span>{{lang.clientValid}}</span>-->
<!--          <span>{{tmVToday}}</span>-->
<!--        </p>-->
         <p @click="lookDetail('showTmTk',lang.tmWithdraw,0)">
          <span>{{lang.tmWithdraw}}</span>
          <span>{{currSymbol}}{{teamWithdraw}}</span>
        </p>
      </div>
      <div class="commission">
        <p>
          <span>{{lang.totalCommission}}</span>
          <span>{{yj}}</span>
        </p>
        <p>
          <span>{{lang.yesterdayCommission}}</span>
          <span>{{yjYest}}</span>
        </p>
      </div>
      <div class="navbox">

        <p :class="{'active':leavlNum==1}" @click="leavlNum=1">{{lang.lv1}}</p>
        <p :class="{'active':leavlNum==2}" @click="leavlNum=2">{{lang.lv2}}</p>
        <p :class="{'active':leavlNum==3}" @click="leavlNum=3">{{lang.lv3}}</p>

      </div>
      <div class="content">
        <ul v-if="level[leavlNum-1]&&level[leavlNum-1].length>0">
          <li class="record-list" v-for="(item,index) in level[leavlNum-1]" :key="index">
            <p><span>{{lang.account}}：<b>{{item.uname}}</b></span></p>
            <p><span>{{lang.ctime}}：<b>{{item.ctime}}</b></span></p>
            <p><span>{{lang.czje}}：<b>{{currSymbol}}{{item.deposit}}</b></span></p>
            <p><span>{{lang.txje}}：<b>{{currSymbol}}{{item.withdraw}}</b></span></p>
<!--             <p><span>{{lang.vipgrade}}：<b>{{item.vip}}</b></span></p>-->
          </li>
        </ul>
        <div class="no-data" v-else>
          <img src="../../assets/images/no-data.png" />
          <p>{{lang.nomore}}</p>
        </div>
      </div>
    </div>
    <mt-popup
      v-model="showRule"
      class="rule-box">
      <div class="rule-content" v-html="rules"></div>
      <div class="btn" @click="showRule=false">{{lang.confirm}}</div>
    </mt-popup>
     <Bottom />
  </div>
</template>
<script type="text/javascript">
import { CONF } from '@/assets/js/config'
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {
        currSymbol: CONF.CURR_SYMBOL,
        teams: 0, //团对总人数
        teamWithdraw: 0, //团队提款
        teamDeposit: 0, //团队充值
        tmToday: 0, //今日新增人数
        yj: 0, //佣金总额
        yjYest: 0, //昨日佣金
        level: [],
        leavlNum: 1,
        showRule:false,
        rules:''//规则
      }
    },
    created() {
      this.getData();
    },
    computed: {
      ...mapState(['lang'])
    },
    methods: {
      getData() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/member/team', {}).then(res => {
            this.$indicator.close();
            this.searchBox = false;
            if (res.data.err == 0) {
              this.teams = res.data.data.teams;
              this.teamWithdraw = res.data.data.teamWithdraw;
              this.teamDeposit = res.data.data.teamDeposit;
              this.tmToday = res.data.data.tmToday;
              this.yj = res.data.data.yj;
              this.yjYest = res.data.data.yjYest;
              this.level = res.data.level;
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              sessionStorage.setItem('tk', res.data.tk);
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          // .catch(error => {
          //   this.$indicator.close();
          //   this.$router.push('/');
          // })
      },
      lookDetail(type,title,n){//n=0全部n=1今日
        this.$router.push({
          name: 'TeamInfo',
          query: {
            routerName:type,
            title:title,
            td:n
          }
        })
      }
    }
  }
</script>
<style type="text/css"  scoped>
  .icon-kongxinwenhao {
    font-size: 18px;
  }

  .totalTj {
    display: flex;
    padding: 12px;
    flex-wrap: wrap;
    border-top: 1px solid rgba(255, 255, 255, .5);
    background: #6595fd;
  }
  .totalTj  p {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #fff;
    text-align: center;
  }
  .totalTj  p  span:last-child {
    font-size: 20px;
  }

  .commission {
    display: flex;
    padding: 12px 0;
    background: #7adaeb;
  }
  .commission  p {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-right: 1px solid rgba(255, 255, 255, .5);
  }
  .commission  p:last-child {
    border-right: none;
  }

  .commission  p span:last-child {
    font-weight: bold;
    font-size: 16px;
  }


  .navbox {
    display: flex;
    background: #fff;
    color: #646566;
  }
  .navbox p {
    flex: 1;
    height: 100%;
    padding: 10px 0;
    margin:3px 0;
    text-align: center;
    position: relative;
  }
  .navbox p.active::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 3px;
    width: 50px;
    height: 2px;
    border-radius: 2px;
    background: #ff5a4b;
  }


  .content {
    flex: 1;
    overflow-y: auto;
    position: relative;
  }
  .content li {
    margin: 12px;
    padding: 12px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 5px 6px rgba(0, 0, 0, .1);
  }
  .content li p {
    display: flex;
    justify-content: space-between;
    line-height: 24px;
    color: #666;
  }
  .content li p b {
    color: #333;
  }

  .content li p .title {
    color: #000;
    font-size: 15px;
    font-weight: bold;
  }

  .content li p .red {
    color: rgb(231, 76, 60);
  }

  .content li p .green {
    color: green;
  }

  .content li p .yellow {
    color: #ffb115;
  }

  .rule-box {
    width: 85%;
    margin: auto;
    border-radius: 10px;
    overflow: hidden;
  }
  .rule-box .rule-content {
    padding: 12px;
    min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
    font-size: 15px;
    color:#666;
    line-height: 30px;
    overflow-wrap: break-word;
    background: #fff;
  }

  .rule-box .btn {
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: #115295;
    font-size: 18px;
    border-top: 1px solid #ddd;
  }
</style>